import * as navigation from 'Navigation';
import {TabStateDefaults} from 'Navigation';

export default class AnalyticsDashboardTabState extends navigation.TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Dashboard',
      closeable: false,
      preferenceKey: 'analytics-dashboard',
    };
  }
}
